import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, Input, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { TranslateModule } from '@ngx-translate/core';
import { combineLatest, Observable } from 'rxjs';
import { filter, map, switchMap } from 'rxjs/operators';

import { getCategoryAttachments, getElementDefaultImageTypes, getFilters } from '../../../../store/category-page.selectors';

import { Category } from '@core/domain/models/category.models';
import { getCmsConfigValue } from '@core/infrastructure/state/core.selectors';
import { GridTypes } from '@shared/models/grid-type.model';
import { ProductViewComponent } from '@shared/product';
import { ProductViewConfig, CategoryConfiguration } from '@shared/product/models';

@Component({
    selector: 'app-grid-last-sizes',
    templateUrl: './grid-last-sizes.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        TranslateModule,
        ProductViewComponent,
        AsyncPipe,
    ],
})
export class GridLastSizesComponent implements OnInit {
    private readonly store: Store = inject(Store);

    @Input() public defaultImageTypes: Map<number, string>;

    @Input() public category: Category;

    @Input() public isCategoryNew: boolean;

    @Input() public gridType: GridTypes;

    @Input() public showMediaCarousel: boolean;

    @Input() public templateConfiguration: ProductViewConfig;

    private readonly getFilters$: Observable<any> = this.store.select(getFilters);

    private readonly enableLastSizes$: Observable<boolean> = this.store.select(getCmsConfigValue('show_last_sizes'));

    private readonly categoryAttachments$: Observable<any> = this.store.select(getCategoryAttachments);

    public categoryConfiguration: CategoryConfiguration;

    public lastSizesIds$: Observable<number[]> = this.enableLastSizes$.pipe(
        filter((enableLastSizes) => enableLastSizes),
        switchMap(() => {
            return combineLatest([this.getFilters$, this.categoryAttachments$]);
        }),
        map(([filters, attachments]) => {
            const enableLastSizesCat = !!attachments?.find((attachment: any) => attachment.name === 'show_last_sizes');
            const filtersApplied = filters.isApplied || filters.order.isApplied;
            if (enableLastSizesCat && !filtersApplied) {
                return filters?.filters?.lastSizesFilter ?? [];
            }
            return [];
        })
    );

    public elementDefaultImageTypes$: Observable<Map<number, string>> = this.store.select(getElementDefaultImageTypes);

    public ngOnInit(): void {
        this.categoryConfiguration = {
            soldOut: false,
            productConf: new Map(),
            category: this.category,
            isCategoryNew: this.isCategoryNew,
        };
    }
}
